import analytics from '../animations/analytics.json';
import calendar from '../animations/calendar.json';
import cluster from '../animations/cluster.json';
import copyWriting from '../animations/copywriting.json';
import lineChart from '../animations/line_chart_4.json';
import messageImproveRobot from '../animations/message_improve_robot.json';
import workingOnTheirWay from '../animations/message_on_their_way.json';
import robotTwo from '../animations/robot-two.json';
import robot from '../animations/robot.json';
import robotForCover from '../animations/robot_for_cover.json';
import task from '../animations/task.json';
import turing from '../animations/turing_4.json';

const ANIMATION: { [key: string]: Object } = {
    robot,
    lineChart,
    turing,
    cluster,
    calendar,
    workingOnTheirWay,
    analytics,
    task,
    robotTwo,
    copyWriting,
    messageImproveRobot,
    robotForCover,
};

export default ANIMATION;
